(() => {
  'use strict';
  const ready = new WeakSet();
  const refreshers = new Set();

  function initialise(scope) {
    scope.querySelectorAll('[data-abtq-title]').forEach(wrapper => {
      if (ready.has(wrapper)) return;
      const title = wrapper.querySelector('[data-abtq-title-text]');
      const toggle = wrapper.querySelector('[data-abtq-title-toggle]');
      if (!title || !toggle) return;
      ready.add(wrapper);
      let pending = false;

      function setExpanded(expanded) {
        wrapper.dataset.expanded = String(expanded);
        toggle.setAttribute('aria-expanded', String(expanded));
        toggle.textContent = expanded ? toggle.dataset.readLess : toggle.dataset.readMore;
      }

      function measure() {
        pending = false;
        if (!wrapper.isConnected) {
          refreshers.delete(scheduleMeasure);
          return;
        }
        wrapper.classList.add('abtq-product-title--ready');
        const expanded = wrapper.dataset.expanded === 'true';
        const style = getComputedStyle(title);
        const lineHeight = parseFloat(style.lineHeight) || parseFloat(style.fontSize) * 1.2;
        const overflow = expanded
          ? title.getBoundingClientRect().height > lineHeight * 2 + 1
          : title.scrollHeight > title.clientHeight + 1;
        toggle.hidden = !overflow;
        if (!overflow && expanded) setExpanded(false);
      }

      function scheduleMeasure() {
        if (pending) return;
        pending = true;
        requestAnimationFrame(measure);
      }

      toggle.addEventListener('click', () => {
        setExpanded(wrapper.dataset.expanded !== 'true');
        scheduleMeasure();
      });
      if ('ResizeObserver' in window) {
        new ResizeObserver(scheduleMeasure).observe(wrapper);
      }
      new MutationObserver(scheduleMeasure).observe(title, { childList: true, characterData: true, subtree: true });
      refreshers.add(scheduleMeasure);
      scheduleMeasure();
    });
  }

  function refresh() {
    refreshers.forEach(schedule => schedule());
  }
  function start() {
    initialise(document);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(refresh);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  window.addEventListener('resize', refresh, { passive: true });
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
